<div class="flex flex-col w-full h-full">
  <div
    class="flex px-6 py-3 flex-row items-center justify-between w-full h-16 min-h-16 border-b-[thin] border-color-light-shade border-solid border-x-0 border-t-0"
  >
    <div class="flex items-center gap-1">
      <p class="text-sm text-color-secondary p-0 m-0">
        {{ 'ASSETS_TREE.TREE_SECTION.FILTERS.TITLE' | translate }}
      </p>
      <div #element class="relative" appClickOutside (clickOutside)="showLocationGroupInput.set(false)">
        <div
          role="button"
          (click)="showLocationGroupInput.set(!showLocationGroupInput())"
          class="flex flex-row items-center font-medium text-color-primary cursor-pointer select-none"
        >
          <span class="text-sm p-0 m-0">
            {{
              assetsTreeFilterService.form.get('locationGroup')?.value?.name ||
                ('ASSETS_TREE.TREE_SECTION.FILTERS.ALL_LOCATIONS_GROUPS' | translate)
            }}
          </span>
          <mat-icon class="transition-all" [ngClass]="{ 'rotate-180': showLocationGroupInput() }">arrow_drop_down</mat-icon>
        </div>

        @if (showLocationGroupInput()) {
          <div
            [@fadeInOut]
            class="z-50 absolute top-8 left-0 min-w-[260px] max-w-[330px] w-full bg-white p-[6px] rounded-md border border-solid border-color-light-shade"
          >
            <fc-search-select
              [placeholder]="'ASSETS_TREE.TREE_SECTION.FILTERS.SEARCH_BY_NAME' | translate"
              [allOptionsLabel]="'ASSETS_TREE.TREE_SECTION.FILTERS.ALL_LOCATIONS_GROUPS' | translate"
              [noOptionsLabel]="'ASSETS_TREE.TREE_SECTION.FILTERS.NO_LOCATIONS_GROUPS' | translate"
              [control]="assetsTreeFilterService.form.get('locationGroup')"
              [service]="locationsGroupsService"
              [searchProperty]="'name_contains'"
            ></fc-search-select>
          </div>
        }
      </div>
    </div>

    <fc-search-input-animated
      [placeholder]="'ASSETS_TREE.TREE_SECTION.FILTERS.SEARCH_BY_NAME_OR_NUMBER' | translate"
      [searchNameInputControl]="assetsTreeFilterService.form.get('nameContains')"
    >
    </fc-search-input-animated>
  </div>

  <ng-scrollbar
    #scrollbarRef
    class="w-full h-full overflow-auto relative"
    [visibility]="'hover'"
    (updated)="onScrollbarUpdate(scrollbarRef)"
  >
    @if (assetsTreeFilterService.isEmptyFiltered() && !assetsTreeFilterService.isLoading()) {
      <div
        class="flex flex-col justify-center items-center gap-8 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
      >
        <img src="assets/images/icons/no-assets.svg" alt="no assets" />
        <div>
          <p class="font-medium text-base text-color-normal text-center m-0 p-0 pb-3">
            {{ 'ASSETS_TREE.NO_ASSETS_FILTERED.TITLE' | translate }}
          </p>
          <p class="font-medium text-sm text-color-secondary text-center m-0 p-0">
            {{ 'ASSETS_TREE.NO_ASSETS_FILTERED.DESCRIPTION' | translate }}
          </p>
        </div>
      </div>
    }

    @if (!assetsTreeFilterService.isLoading()) {
      <div class="w-full flex flex-col px-6 py-5 gap-3" [@listAnimation]="assetsTreeFilterService.locations().length">
        @for (location of assetsTreeFilterService.locations(); track $index; let index = $index) {
          <tree-view [item]="location" [service]="treeSectionService" [level]="0"></tree-view>
        }
      </div>
    }

    @if (assetsTreeFilterService.isLoadingMore()) {
      <div [@fadeInOut] class="flex flex-col justify-center items-center mb-5">
        <mat-spinner diameter="24" color="primary"></mat-spinner>
      </div>
    }

    @if (assetsTreeFilterService.isLoading()) {
      <div
        [@fadeInOut]
        class="flex flex-col gap-10 items-center justify-center absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
      >
        <pulse-animation-component class="w-20 h-20" icon="assetsTree"></pulse-animation-component>
        <div class="flex flex-col gap-3">
          <span class="text-color-primary text-base font-medium w-full text-center">
            {{ 'ASSETS_TREE.TREE_SECTION.LOADING.HEADLINE' | translate }}
          </span>
          <span class="text-sm text-color-secondary w-full">
            {{ 'ASSETS_TREE.TREE_SECTION.LOADING.SUPPORT' | translate }}
          </span>
        </div>
      </div>
    }
  </ng-scrollbar>

  <div
    class="flex px-6 py-3 flex-none flex-row items-center justify-between w-full h-16 min-h-16 border-t-[thin] border-color-light-shade border-solid border-x-0 border-b-0"
  >
    <div class="flex gap-5 items-center">
      <p class="text-sm font-semibold text-color-neutral m-0 p-0">
        {{ 'ASSETS_TREE.TREE_SECTION.FOOTER.TITLE' | translate }}
      </p>
      <div class="flex items-center gap-1">
        <mat-icon class="max-h-4 h-4 max-w-4 w-4 text-[16px] text-color-primary">place</mat-icon>
        <p class="m-0 p-0 text-color-secondary text-sm">{{ 'ASSETS_TREE.TREE_SECTION.FOOTER.LOCATION' | translate }}</p>
      </div>
      <div class="flex items-center gap-1">
        <mat-icon class="max-h-4 h-4 max-w-4 w-4 text-[16px] text-color-primary">gite</mat-icon>
        <p class="m-0 p-0 text-color-secondary text-sm">{{ 'ASSETS_TREE.TREE_SECTION.FOOTER.SECTOR' | translate }}</p>
      </div>
      <div class="flex items-center gap-1">
        <mat-icon class="max-h-4 h-4 max-w-4 w-4 text-[16px] text-color-primary">meeting_room</mat-icon>
        <p class="m-0 p-0 text-color-secondary text-sm">{{ 'ASSETS_TREE.TREE_SECTION.FOOTER.ENVIRONMENT' | translate }}</p>
      </div>
      <div class="flex items-center gap-1">
        <mat-icon class="max-h-4 h-4 max-w-4 w-4 text-[16px] text-color-primary">precision_manufacturing</mat-icon>
        <p class="m-0 p-0 text-color-secondary text-sm">{{ 'ASSETS_TREE.TREE_SECTION.FOOTER.EQUIPMENT' | translate }}</p>
      </div>
    </div>
  </div>
</div>
